// extracted by mini-css-extract-plugin
module.exports = {"container":"fixedcards_container__k5SHZ","cardContainer":"fixedcards_cardContainer__EhqTF"};